"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var StyledTextArea = (0, react_1.styled)("textarea", {
    borderStyle: "solid",
    borderWidth: "1px",
    resize: "none",
    width: "360px",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    boxShadow: stitches_config_1.theme.shadows.shadowInner,
    background: stitches_config_1.theme.colors.white,
    color: stitches_config_1.theme.colors.gray12,
    padding: "8px 12px",
    "&::placeholder": {
        color: stitches_config_1.theme.colors.gray11,
        opacity: 1,
    },
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    fontFamily: "Inter",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        hasValue: {
            true: {},
            false: {},
        },
        error: {
            true: {
                borderColor: stitches_config_1.theme.colors.red7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.red8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.red9,
                    boxShadowColor: stitches_config_1.theme.colors.error,
                    outline: "none",
                },
            },
            false: {
                borderColor: stitches_config_1.theme.colors.gray7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.blue9,
                    boxShadowColor: stitches_config_1.theme.colors.focus,
                    outline: "none",
                },
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
    defaultVariants: {},
});
function Textarea(props) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsx)(StyledTextArea, { onClick: function (e) {
            e.stopPropagation();
        }, disabled: props.disabled, rows: (_a = props.rows) !== null && _a !== void 0 ? _a : 3, placeholder: props.placeholder, value: props.value, onChange: props.onChange, hasValue: !props.value, id: props.id, onBlur: props.onBlur, error: (_b = props.error) !== null && _b !== void 0 ? _b : false, fullWidth: props.fullWidth }));
}
exports.Textarea = Textarea;
//# sourceMappingURL=Textarea.js.map